<div class="modal-header">
    <ion-button (click)="closeModal()" data-cy="change-log-modal-close-button" fill="solid">
        <ion-icon name="close" slot="icon-only"></ion-icon>
    </ion-button>
</div>
<div class="container">

    <ion-icon class="changelog-icon; ion-align-self-center" name="newspaper-outline" />

    <h1>Nieuw in versie 2.16!</h1>

    <h2>v2.16.5 - 2 juli 2025</h2>

    <h3 class="changelog-add">Toegevoegd</h3>

    <ul>
        <li>De callsheets kunnen weer via de app worden gedownload. Met het veranderen van de server heb ik de
            documenten op een
            andere manier opgeslagen en dat kon door de app niet gelezen worden. Ik heb daar een workaround voor
            geimplementeerd
            waarbij je de pdf in je browser download. Ik ben nog bezig met een nog mooiere oplossing.
        </li>
        <li>De callsheets zijn nu ook te vinden op de Speeldata pagina. Op die manier kun je ook de callsheets zien voor
            de shows
            in de toekomst (wat waarschijnlijk dus steeds maar 1 show van te voren is omdat we de callsheets slechts 1
            show van te
            voren maken, maar dat is alsnog winst!).
        </li>
        <li>Op het dashboard in de desktop-versie kun je nu zien of er bij een showreport een opmerking is geplaatst bij
            een van
            de technische onderdelen. Je kunt dan direct op het vinkje (of kruisje) klikken en dan zie je de opmerking.
            Zo heb je
            vanaf het dashboard sneller een globaal overzicht en door het showreport te openen kun je naar de details
            gaan.
        </li>
    </ul>
    <h3 class="changelog-change">Gewijzigd</h3>

    <ul>
        <li>Ik heb in de App Icon de tekst 'TEST' vervangen door 'LOGBOEK'. Hoewel we nog steeds lekker in de praktijk
            aan het
            testen zijn, komen we steeds dichter bij het punt waarop de app zelfstandiger functioneert (oftewel dat ik
            steeds
            minder handmatig in de database hoef te rommelen).
        </li>
        <li>Diverse kleine optimalisaties en bugfixes.</li>
    </ul>

    <div style="text-align: center; border-top: 2px solid var(--ion-color-primary); padding-top: 2rem; padding-bottom: 2rem;">
        Zoals altijd geldt:<br><br>Heb je een idee, een wens of een bug?<br>Laat het me weten!
    </div>

    <ion-button (click)="closeModal()" style="min-height: 40px;">
        Scherm Sluiten
    </ion-button>

</div>